import { FieldSelect } from '@dixa/lib-shared-habla';
import {
  getNodeEntries,
  getNodeString,
  isType,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import {
  ELEMENT_HEADING_LARGE,
  ELEMENT_HEADING_MEDIUM,
  ELEMENT_HEADING_SMALL,
} from 'lib-knowledge-document-structure/plateTypes';

type ElementLookupProps = {
  onSelect: (elementId: string) => void;
  value: string | null;
  readOnly: boolean;
};

/* Renders a component for linking headings, providing a searchable dropdown interface. */
export const HeadingLinkLookup = ({
  onSelect,
  value,
  readOnly,
}: ElementLookupProps): JSX.Element => {
  const editor = useMyEditorRef();

  const nodes = getNodeEntries(editor, {
    // Look at all nodes
    mode: 'all',
    // Don't need to look for 'voids' as headings are not voids (images, videos, etc.)
    voids: false,
    // Only look for blocks.
    block: true,
    // Override looking at current selection and look at whole doc
    at: [],
    match: (node) => {
      return isType(editor, node, [
        ELEMENT_HEADING_LARGE,
        ELEMENT_HEADING_MEDIUM,
        ELEMENT_HEADING_SMALL,
      ]);
    },
  });

  // TODO: filter out current element?, just in case a heading is linked to itself
  const headingItems = Array.from(nodes).map(([node]) => {
    return {
      // @ts-expect-error - TS doesn't know I've narrowed the element types
      id: node.id,
      name: getNodeString(node),
    };
  });

  return (
    <FieldSelect
      label="Headings"
      input={{
        name: 'headingLookup',
        value: value ? [value] : [],
        onChange: onSelect,
      }}
      items={headingItems}
      disabled={readOnly}
    />
  );
};
